import CloseIcon from "@mui/icons-material/Close";
import { Button, Link } from "@mui/material";
import Grid from "@mui/material/Unstable_Grid2";
import React from "react";
import SlidingPanel from "react-sliding-side-panel";
import RKTextField from "../../../../../Supporting files/RKTextField/RKTextField";
import SearchDropdown from "../../../../../Supporting files/SearchDropdown/SearchDropdown";
import SelectDropdown from "../../../../../Supporting files/SelectDropdown/SelectDropdown";
interface Props {
  open_status: boolean;
  attrName: any;
  value_update: Function;
}

const AddProperty: React.FC<Props> = ({
  open_status,
  attrName,
  value_update,
}) => {
  const [propertyType, setPropertyType] = React.useState("Owned");
  const [propertyAge, setPropertyAge] = React.useState("1-5 Years");
  const [buildingType, setBuildingType] = React.useState("Independent");
  const [streetName, setStreetName] = React.useState("#6, Building");
  const [areaName, setAreaName] = React.useState("Phase 9, Industrial Area");
  const [country, setCountry] = React.useState("India");
  const [state, setState] = React.useState("U.K.");
  const [city, setCity] = React.useState("Dehradun");
  const [zipCode, setZipCode] = React.useState("248001");

  const propertyType_data = [
    { key: "Owned", value: "Owned" },
    { key: "Owned", value: "Owned" },
  ];
  const propertyAge_data = [
    { label: "1-5 years", value: "1-5 years" },
    { label: "5-10 years", value: "5-10 years" },
  ];
  const buildingType_data = [
    { key: "Independent", value: "Independent" },
    { key: "MultiStory", value: "MultiStory" },
  ];
  const country_data = [
    { label: "India", value: "India" },
    { label: "Australia", value: "Australia" },
    { label: "England", value: "England" },
  ];
  const state_data = [
    { label: "U.K.", value: "U.K." },
    { label: "Haryana", value: "Haryana" },
    { label: "Rajasthan", value: "Rajasthan" },
  ];
  const city_data = [
    { label: "Dehradun", value: "Dehradun" },
    { label: "Chandigarh", value: "Chandigarh" },
    { label: "Mohali", value: "Mohali" },
  ];

  const updateMasterState = (attrName: any, value: any) => {
    attrName(value);
  };

  return (
    <>
      <SlidingPanel
        type={"right"}
        isOpen={open_status}
        size={75}
        panelClassName="slidingPanel"
        // backdropClicked={() => value_update(attrName, false)}
      >
        <>
          <Grid container spacing={3} alignItems="center">
            <Grid xs={10}>
              <h4 className="mb-0 mt-3 text-left">Add Property</h4>
            </Grid>
            <Grid xs={2} textAlign="end" className="mt-2">
              <Link
                className="closeIcon"
                onClick={() => {
                  value_update(attrName, false);
                }}
              >
                <CloseIcon />
              </Link>
            </Grid>
            <Grid xs={12}>
              <hr />
            </Grid>
          </Grid>
          <div className="scrollable_area">
            <div>
              <Grid container spacing={3}>
                <Grid xs={6}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Property Type"
                    value={propertyType}
                    attrName={setPropertyType}
                    value_update={updateMasterState}
                    dropdown_data={propertyType_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Property Age"
                    value={propertyAge}
                    attrName={setPropertyAge}
                    value_update={updateMasterState}
                    data={propertyAge_data}
                    warn_status={false}
                    error_message="Please select age"
                  />
                </Grid>
                <Grid xs={12}>
                  <SelectDropdown
                    class_name="inputField"
                    title="Building Type"
                    value={buildingType}
                    attrName={setBuildingType}
                    value_update={updateMasterState}
                    dropdown_data={buildingType_data}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Building/Street Name"}
                    value={streetName}
                    attrName={setStreetName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Area Name"}
                    value={areaName}
                    attrName={setAreaName}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="Country"
                    value={country}
                    attrName={setCountry}
                    value_update={updateMasterState}
                    data={country_data}
                    warn_status={false}
                    error_message="Please select Country"
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="State"
                    value={state}
                    attrName={setState}
                    value_update={updateMasterState}
                    data={state_data}
                    warn_status={false}
                    error_message="Please select State"
                  />
                </Grid>
                <Grid xs={6}>
                  <SearchDropdown
                    class_name="inputField"
                    title="City"
                    value={city}
                    attrName={setCity}
                    value_update={updateMasterState}
                    data={city_data}
                    warn_status={false}
                    error_message="Please select city"
                  />
                </Grid>
                <Grid xs={6}>
                  <RKTextField
                    class_name="inputField"
                    title={"Zip Code"}
                    value={zipCode}
                    attrName={setZipCode}
                    value_update={updateMasterState}
                    warn_status={false}
                  />
                </Grid>
              </Grid>
              <Grid container spacing={3}>
                <Grid
                  xs={12}
                  className="ctaBtn"
                  style={{ textAlign: "center" }}
                >
                  <Button
                    variant="contained"
                    className="submitBtn"
                    onClick={() => {}}
                  >
                    Submit
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </>
      </SlidingPanel>
    </>
  );
};

export default AddProperty;
